import { Skeleton } from '../../../Skeleton'
import { VIEWING_APPLICANT_PREVIEW_SKELETON_ROWS } from '../RentalPortalViewingApplicantPreviewModal.constants'

import * as styles from './ViewingApplicantPreviewSkeleton.module.css'

function ViewingApplicantPreviewSkeleton() {
  return (
    <>
      {Array.from(
        { length: VIEWING_APPLICANT_PREVIEW_SKELETON_ROWS },
        (_, index) => (
          <Skeleton className={styles.row} key={index} />
        )
      )}
    </>
  )
}

export default ViewingApplicantPreviewSkeleton
